/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roomannouncementnobodyinside3Inputs */

const en_roomannouncementnobodyinside3 = /** @type {(inputs: Roomannouncementnobodyinside3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody is inside right now.`)
};

const de_roomannouncementnobodyinside3 = /** @type {(inputs: Roomannouncementnobodyinside3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade ist niemand im Raum.`)
};

/**
* | output |
* | --- |
* | "Nobody is inside right now." |
*
* @param {Roomannouncementnobodyinside3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementnobodyinside3 = /** @type {((inputs?: Roomannouncementnobodyinside3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementnobodyinside3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementnobodyinside3(inputs)
	return de_roomannouncementnobodyinside3(inputs)
});
export { roomannouncementnobodyinside3 as "roomAnnouncementNobodyInside" }